<template>
  <button
    v-bind="{ disabled, ...$attrs }"
    :aria-busy="loading"
    :class="['aeropay-button w-full px-600 py-150 rounded-full', { disabled, loading }]"
    :tabindex="disabled || loading ? -1 : 0"
    type="button"
  >
    <div v-if="loading" class="spinner-wrapper">
      <LcIcon class="spinner" name="loader" />
    </div>

    <div class="content flex items-center justify-center gap-150">
      <img :alt="$t('payout.aeropay.button.logoalt')" src="assets/img/payment/aeropay-btn.svg" />
    </div>
  </button>
</template>

<script lang="ts" setup>
type PayoutMethodAeropayButtonProps = {
  disabled?: boolean
  loading?: boolean
}

defineProps<PayoutMethodAeropayButtonProps>()
</script>

<style lang="scss" scoped>
.aeropay-button {
  @include focus-state {
    &::before {
      @include focus-state-button;

      inset: 0.688rem 1.063rem;
      border-radius: token('size/radius/full');
      background-color: unset;
    }
  }

  background-color: #f2fcfd;
  color: #00181a;
  font-weight: 500;
  font-style: normal;
  font-size: 1rem;
  font-family: SF-Pro-Display, sans-serif;
  line-height: 1.75rem;
  letter-spacing: 0.003rem;
  text-align: center;
  cursor: pointer;

  .content {
    white-space: nowrap;
  }

  &.disabled {
    background: #f2fcfd;
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }

  &.loading {
    cursor: not-allowed;
    pointer-events: wait;

    .content {
      opacity: 0;
    }
  }

  .spinner-wrapper {
    position: absolute;
    inset: 0;
    display: flex;
    gap: token('size/space/gap/100');
    justify-content: center;
    align-items: center;

    .spinner {
      animation: lc-button-spin 1600ms linear infinite;
    }
  }

  &:not(.disabled, .loading):hover {
    background-color: #f8ffff;
  }

  &:not(.disabled, .loading):active {
    background-color: #eaf4f5;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
